import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const LOADING = (
  <div className="min-h-screen flex items-center justify-center bg-[#f8f7fb]">
    <div className="flex flex-col items-center gap-3">
      <div className="w-10 h-10 rounded-full border-2 border-[#5B21B6] border-t-transparent animate-spin" />
      <p className="text-[#5B21B6] text-sm font-medium">Loading...</p>
    </div>
  </div>
);

export default function ProtectedRoute({ children, role }) {
  const { user, isGuest } = useAuth();

  if (user === undefined) return LOADING;

  // Guests may browse all diner pages — individual pages gate restricted actions themselves
  if (isGuest && role === 'diner') return children;

  if (!user) {
    const loginPath = role === 'vendor' ? '/vendor/login' : role === 'admin' ? '/admin/login' : '/login';
    return <Navigate to={loginPath} replace />;
  }

  if (role && user.role !== role) {
    const redirect = user.role === 'admin' ? '/admin' : user.role === 'vendor' ? '/vendor/dashboard' : '/diner/discover';
    return <Navigate to={redirect} replace />;
  }

  return children;
}
